import { UntypedFormControl, Validators } from '@angular/forms';
import { ValidatorsService } from '@core/Abstract/validators/validators.service';
import {
  AlphaNumericValidator, AlphaNumericAndSpecialCharsValidator, dateFutureValidator,
  currencyValidator, EmailValidator, NumericValidator, AsyncIbanValidator, signedCurrencyValidator
} from '@core/Abstract/validators/validators';
import { TranslateService } from '@ngx-translate/core';

export function registerValidators(translate: TranslateService, validatorsService: ValidatorsService) {
  return {
    validationMessages: [
      {
        name: 'required',
        message() {
          return translate.stream('GENERIC.REQUIRED');
        },
      },
      {
        name: 'alphaNumeric',
        message() {
          return translate.stream('GENERIC.ALPHANUMERIC');
        },
      },
      {
        name: 'numeric',
        message() {
          return translate.stream('GENERIC.NUMERIC');
        },
      },
      {
        name: 'alphanumericandspecialchars',
        message() {
          return translate.stream('GENERIC.ALPHANUMERICANDSPECIALCHARS');
        },
      },
      {
        name: 'iban',
        message() {
          return translate.stream('GENERIC.INVALIDIBAN');
        },
      },
      {
        name: 'minLength',
        message(err, field) {
          const minLengthPrefix = translate.instant('GENERIC.MINLENGTHPREFIX');
          const minLengthSuffix = translate.instant('GENERIC.MINLENGTHSUFFIX');
          return `${minLengthPrefix} ${field.templateOptions.minLength} ${minLengthSuffix}`;
        },
      },
      {
        name: 'email',
        message() {
          return translate.stream('GENERIC.INVALIDEMAIL');
        }
      }
    ],
    validators: [
      { name: 'requiredTrue', validation: Validators.requiredTrue },
      { name: 'alphaNumeric', validation: AlphaNumericValidator },
      { name: 'alphanumericandspecialchars', validation: AlphaNumericAndSpecialCharsValidator },
      { name: 'numeric', validation: NumericValidator },
      { name: 'email', validation: EmailValidator },
      { name: 'date-future', validation: dateFutureValidator },
      { name: 'currency', validation: currencyValidator },
      { name: 'signedCurrency', validation: signedCurrencyValidator },
      {
        name: 'iban',
        validation: (control: UntypedFormControl) => {
          return AsyncIbanValidator(control, validatorsService);
        }
      }
    ]
  };
}